import type {
  CampaignsQueryParams,
  TemplatesQueryParams,
} from "../../types.ts";

// Query keys for React Query
export const whatsappCampaignKeys = {
  all: ["whatsappCampaigns"] as const,
  list: (params: CampaignsQueryParams | undefined) =>
    [...whatsappCampaignKeys.all, "list", params] as const,
  detail: (id: string) => [...whatsappCampaignKeys.all, "detail", id] as const,
  templates: (params: TemplatesQueryParams) =>
    [...whatsappCampaignKeys.all, "templates", params] as const,
};
